import React from "react";
import {
  FaHandsHelping,
  FaProjectDiagram,
  FaPaintBrush,
  FaBusAlt,
} from "react-icons/fa";

const teachingData = [
  {
    title: "Hands-on Activities",
    time: "9.00am - 9.45pm",
    desc: "Annual exhibitions & active clubs help students apply learning.",
    icon: <FaHandsHelping />,
  },
  {
    title: "Project Work",
    time: "9.00am - 9.45pm",
    desc: "Students explore science and the world through projects.",
    icon: <FaProjectDiagram />,
  },
  {
    title: "Drawing Classes",
    time: "9.00am - 9.45pm",
    desc: "Drawing improves creativity, focus and imagination.",
    icon: <FaPaintBrush />,
  },
  {
    title: "Tours & Visits",
    time: "9.00am - 9.45pm",
    desc: "Educational trips help students think outside classroom.",
    icon: <FaBusAlt />,
  },
];
const TeachingMethodology = () => {
  return (
    <section className="py-16 px-4 md:px-8 bg-gradient-to-br from-orange-50 via-white to-red-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold text-red-600 bg-red-100 rounded-full mb-3">
            Our Learning Approach
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
            Teaching{" "}
            <span className="bg-gradient-to-r from-red-600 to-orange-500 bg-clip-text text-transparent">
              Methodology
            </span>
          </h2>
          <p className="text-gray-600 text-sm mt-3">
            Practical and joyful learning for every child.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {teachingData.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-[26px] shadow-lg hover:shadow-xl p-5 border border-orange-100 transition-all duration-500"
            >
              <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-red-600 to-orange-500 text-white flex items-center justify-center text-xl mb-4">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs font-semibold text-red-600 mb-3">
                {item.time}
              </p>
              <p className="text-gray-600 text-sm leading-6 mb-4">
                {item.desc}
              </p>
              <div className="border-t border-gray-100 pt-4">
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div className="bg-red-50 rounded-xl py-3 px-2">
                    <p className="text-[10px] text-gray-500 font-medium">
                      Capacity
                    </p>
                    <h4 className="text-xs font-bold text-gray-800 mt-1">
                      20 kids
                    </h4>
                  </div>
                  <div className="bg-orange-50 rounded-xl py-3 px-2">
                    <p className="text-[10px] text-gray-500 font-medium">
                      Duration
                    </p>
                    <h4 className="text-xs font-bold text-gray-800 mt-1">
                      45 min
                    </h4>
                  </div>
                  <div className="bg-red-50 rounded-xl py-3 px-2">
                    <p className="text-[10px] text-gray-500 font-medium">
                      Age
                    </p>
                    <h4 className="text-xs font-bold text-gray-800 mt-1">
                      5y - 6y
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeachingMethodology;